import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {AuthOPEEnum} from "./AuthOPEEnum";

class I {
  userId!: number;
}

class O {
  revokedSessions!: number;
}

export class RevokeUserSessionsCB extends BaseSpringServiceCB {
  public i: I;
  public o: O;

  constructor() {
    super(AuthOPEEnum.RevokeUserSessions);
    this.i = new I();
    this.o = new O();
  }
}
